import Footer from '~/components/Footer'
import Navigation from '~/components/Navigation'

export default function Terms() {
  return (
    <>
      <Navigation />
      <div className="w-full max-w-3xl mx-auto px-4 flex flex-col gap-4">
        <h1 className="pt-3">Terms of Service</h1>

        <p>
          These terms and conditions (the “Terms”) shall always apply to the use of the Application
          (as defined in section 1 below), between the user of the Application (“You”) and the
          provider of the Application; Heja Sports AB (“Heja”), Swedish reg. no. 559147-3177, a
          company incorporated under the laws of Sweden and whose registered office is located at
          Folkungagatan 122, 116 30 Stockholm, SWEDEN. You may only use Heja if You accept to comply
          with and be bound by the Terms. Please read the Terms carefully before You start using our
          services, as these will apply to Your use of the Application.
        </p>

        <p>
          Heja reserves the right to, at any time and for any reason, amend the Terms. You will be
          notified by all amendments, e.g. by push notification and the amended Terms will also be
          published in Heja. The amended Terms shall be effective thirty (30) days after they are
          initially posted in Heja.
        </p>

        <h4>1. DEFINITIONS</h4>

        <h5>1.1</h5>

        <p>
          “Application” means, in the Terms, the website, Heja’s mobile applications named Heja and
          the services provided through them.
        </p>

        <h5>1.2</h5>

        <p>
          “Information” means, in the Terms, all images, logotypes, trademarks, videos, copyright
          protected information and all other information and data that You or anyone else upload
          and/or publish or in other available for others at or via the Application.
        </p>

        <h4>2. REGISTRATION AND USER INFORMATION</h4>

        <h5>2.1</h5>

        <p>
          By registering a user account for the Application, or by upgrading an existing user
          account to a premium account, You enter into an agreement with Heja, whereupon the Terms
          enter into force. By doing so, You warrant that You have the legal capacity and are at the
          legal age, or have the legal consent (e.g. from Your to enter into an agreement that
          legally bind You to the obligations set forth in the Terms. If You register an
          organization, You also warrant that You have the legal capacity to accept the Terms on
          behalf of such organization, and that You have the right to register, represent and act on
          behalf of such organization.
        </p>

        <h5>2.2</h5>

        <p>
          When You register a user account, You warrant that all information about You and/or the
          organization is up to date and correct.
        </p>

        <h5>2.3</h5>

        <p>
          Your login credentials to the Application are confidential and You are responsible to keep
          them confidential at all times. This includes, for instance, to never reveal them to
          anyone else.
        </p>

        <h5>2.4</h5>

        <p>
          You agree that You will be solely responsible for any and all access or use of the
          Application that occurs from Your account and that Heja is authorized to use the
          registered activity of Your account as conclusive evidence that You have accessed and
          utilized the Application.
        </p>

        <h5>2.5</h5>

        <p>
          You acknowledge and accept Heja’s use of external payment providers to enable the You to
          pay for the premium version of the Application, e.g. through Appstore or Google Play. If
          or when You purchase the premium version, You undertake to review and approve the payment
          providers&apos; separate general terms for payments.
        </p>

        <h4>3. INTELLECTUAL PROPERTY RIGHTS</h4>

        <h5>3.1</h5>

        <p>
          All Information, software, equipment, data and other material developed or provided by
          Heja, or its suppliers or affiliates or otherwise used by Heja to provide the Application,
          including all intellectual property rights connected thereto, shall remain the sole and
          exclusive property of Heja or its suppliers. You agree to not, except when expressly
          allowed by the Terms, sell, license, rent, sublicense, modify, distribute, copy,
          reproduce, transmit, publicly display or perform, publish, adapt, editor or create
          derivative works of the content of the Application or any other way make such content
          available for someone else without Heja’s written consent.
        </p>

        <h5>3.2</h5>

        <p>
          When uploading Information, You are personally responsible for acquiring all necessary
          rights of use, operation, reproduction, representation, adaption, disclosing and
          publishing to the Information. You are not allowed to import or use Information that (i)
          infringes third party’s intellectual property rights, trade secrets or other rights of any
          other person or entity, (ii) are incorrect or misleading, (iii) constitutes unauthorized
          or unsolicited advertising or spamming, (iv) is unlawful, threatening, abusive, harassing,
          fraudulent, pornographic or otherwise can be interpreted as offensive, (v) imposes an
          unreasonable or disproportionately (in the sole judgment of Heja) large load on Heja’s
          computing, storage or communications infrastructure or attempts to gain unauthorized
          access to the Application or other accounts, (vi) contains sensitive personal data, or
          (vii) contains software viruses or other harmful components.
        </p>

        <h5>3.3</h5>

        <p>
          By publishing Information or in other ways make Information available for others at or via
          the Application You give Heja an unlimited right to, free of any charge, manage and
          dispose the Information by, for example, process, store or copy the Information with
          purpose to fulfil our commitments.
        </p>

        <h5>3.4</h5>

        <p>
          Heja has the right to, at any time and without prior notice, delete any and all
          Information or other content in case it infringes third party’s intellectual property
          rights, trade secrets or other rights of any other person or entity or results in
          violation of the Terms. Heja’s exercise of this right shall not entitle You to any
          remuneration.
        </p>

        <h4>4. USE</h4>

        <h5>4.1</h5>

        <p>
          The Application and all other services provided by Heja shall be used with common sense,
          which means that You shall not spam, dishonor or be rude to other users.
        </p>

        <h5>4.2</h5>

        <p>
          You undertake to comply with the at all times applicable instructions, technical
          specifications and other regulations that Heja provides for the use of the Application.
        </p>

        <h5>4.3</h5>

        <p>
          You undertake to use the Application only for its intended purpose and not in breach of
          the Terms or to applicable law. When You use the Application and all other services
          provided by Heja You therefore warrant and accept that You:
        </p>

        <p>
          a) shall not demean, patronize or in other ways violate any right of anyone else,
          including Heja;
        </p>

        <p>
          b) shall not publish or in any other way make available offensive material or other
          material that is inappropriate, defamatory, infringing, obscene, pornographic, racist,
          indecent or unlawful;
        </p>

        <p>
          c) shall not, in any way, assist or contribute to spreading viruses or spam or anything
          else that might harm the Application or another user’s property;
        </p>

        <p>
          d) are solely responsible for ensuring that You have the rights necessary to use, upload,
          publish and in other ways distribute the Information, and that You accept that it is
          prohibited to upload, publish or in other ways distribute Information on the Application
          for which You do not have the rights necessary for Your use of the Information;
        </p>

        <p>
          e) are not allowed to download Information that You know, or reasonably should know, is
          not allowed to reproduce, make available, copy, distribute or in any other way use so that
          Your use results in infringement of third party’s right.
        </p>

        <h4>5. YOUR ACCOUNT</h4>

        <h5>5.1</h5>

        <p>
          As a registered user of the Application (a “Member”) You will have different functions and
          roles and in most cases connected to an organization/team (a “Group”).
        </p>

        <p>
          a) As an admin Member (an “Admin”) You will, for instance, control a specific Group with
          more possibilities to add, edit and delete Information.
        </p>

        <p>
          b) The account for a Member is for someone who is not an Admin but is connected to a
          Group.
        </p>

        <h5>5.2</h5>

        <p>
          You accept that other Members will have the right to act within the competence of their
          specific roles/account types.
        </p>

        <h5>5.3</h5>

        <p>
          Should someone unauthorized have the rights of an Admin or in other ways control a
          specific Group, which claim to represent a certain organization/team, Heja will have the
          right to shut down the connectivity for unauthorized Admin and instead give it to someone
          authorized by the organization/team.
        </p>

        <h5>5.4</h5>

        <p>
          In order to improve and develop the Application, Heja has the right to, at any time and
          without prior notice, change the rights linked to the different types of Members or an
          Admin.
        </p>

        <h4>6. PRIVACY</h4>

        <h5>6.1</h5>

        <p>
          Your privacy and the protection of Your data are very important to us. You acknowledge
          that You have received and read in full the terms of our Privacy Policy incorporated into
          these General Terms and Conditions by reference, which explains how and for what purposes
          we collect, use, retain, disclose and safeguard the information You provide to us.
        </p>

        <h5>6.2</h5>

        <p>
          For Your own safety, we recommend that You never publish Your social security number,
          passport number, bank account number, password or other highly sensitive information
          (“confidential information”) in the application otherwise than explicitly requested by
          Heja. In case of failure to comply to this recommendation, Heja is not responsible for the
          confidential information posted in the application and shall not be liable for damages
          directly or indirectly caused by any confidential information that is published.
        </p>

        <h4>7. LIMITATION OF LIABILITY</h4>

        <h5>7.1</h5>

        <p>
          Heja and our affiliates, assignees, officers, employees, agents or other application users
          shall not, to the maximum extent permitted by law, be responsible or liable for any
          direct, indirect, incidental, special, consequential or exemplary damages, (including but
          not limited to, loss of profits, personal injuries, death, goodwill, damaged goods,
          limitations in use, loss of Information or data) even if a party has been the possibility
          of such damages. Heja and our affiliates, assignees, officers, employees, agents or other
          application users shall neither be responsible or liable for any compensation,
          reimbursement, or damages caused in connection with (i) Your use or misuse of the
          application, (ii) other user’s use or misuse of Your Information, (iii) the cost of
          procurement of substitute goods or services, (iv) damages caused by third-party systems,
          and (v) any unauthorized access to, alteration of, or the deletion, destruction, damage,
          loss or failure to store any of Your information or other data. In any case, Heja and our
          affiliates, assignees, officers, employees, agents or other application users, aggregate
          liability under this agreement and for Your use of the application shall be limited to the
          amount You actually pay to Heja for Your use of the application during the twelve (12)
          months preceding the claim.
        </p>

        <h4>8. NO WARRANTIES</h4>

        <h5>8.1</h5>

        <p>
          The application, all its content and all products and services provided by Heja, our
          affiliates and assignees are provided, except to the extent prohibited by the law, “as
          is”, “as available” and, without any warranties of any kind, expressed or implied,
          including but not limited to merchantability, Your expectations of the application, the
          information´s accuracy, trueness or correctness or non-infringements. Hence, Heja, our
          affiliates and assignees do not warrant that (i) the content of the application is
          accurate, reliable or correct, (ii) the application will be available at any particular
          time or location, (iii) any content or software available at or through the application is
          free of viruses or other harmful components, or (iv) the result of using the application
          will meet Your requirements. The use of the application is solely at Your own risk.
        </p>

        <h4>9. INDEMNIFICATION</h4>

        <h5>9.1</h5>

        <p>
          You shall indemnify Heja and our affiliates, assignees, officers, employees and agents
          with respect to all liability, losses damages, costs, lost profits or other expenses
          howsoever caused, arising out of or in connection with (i) Your breach of the Terms, (ii)
          Your gross negligence, (iii) Your uploaded or otherwise supplied information, and (iv)
          Your use or misuse of the application.
        </p>

        <h4>10. LIMITED ACCESS AND TERMINATION</h4>

        <h5>10.1</h5>

        <p>
          If You act in conflict with the Terms or other user instructions or if Heja, in its sole
          discretion, believe that You might do so, Heja has the right to limit, restrict or stop
          Your access to the Application and/or Your user account.
        </p>

        <h5>10.2</h5>

        <p>
          Heja also reserves the right to limit, restrict or stop Your access to the Application or
          remove Your user account and delete Your Information, without prior notice or liability,
          if the Information or Your continued use of the Application risks harming Heja’s trademark
          or reputation.
        </p>

        <h5>10.3</h5>

        <p>
          Heja’s exercise of the rights mentioned above shall not entitle You to any remuneration.
        </p>

        <h4>11. DURATION AND TERMINATION</h4>

        <h5>11.1</h5>

        <p>
          These Terms are in effect from the registration or upgrade of Your user account and
          remains in effect for as long as you use the Application. You can terminate the agreement
          between You and Heja by deleting Your registered account. When You delete Your registered
          account, You agree that Heja will save and store Your Information and that Heja is allowed
          to use and exploit the same in any manner Heja sees fit.
        </p>

        <h5>11.2</h5>

        <p>
          Any saved Information will, when Your registered profile is deleted, be anonymized, so to
          have no connection with You or Your deleted profile, and will be seen as material
          generated from Heja.
        </p>

        <h4>12. ASSIGNMENT OF THE AGREEMENT</h4>

        <h5>12.1</h5>

        <p>
          You may not in wholly or partly assign or pledge You rights and/or obligations under the
          Terms to any third party without the prior written approval of Heja.
        </p>

        <h4>13. SEVERABILITY</h4>

        <h5>13.1</h5>

        <p>
          If any provision of the Terms is held to be invalid or unenforceable, such provision shall
          be limited, modified or severed to the minimum extent necessary to eliminate its
          invalidation or unenforceability so that the Terms otherwise remain in full force, effect
          and enforceability.
        </p>

        <h4>14. WAIVER</h4>

        <h5>14.1</h5>

        <p>
          Heja’s failure to exercise its rights or failure to declare that Your default shall not
          conclude a waiver of Heja’s rights under the Terms.
        </p>

        <h4>15. GOVERNING LAW AND DISPUTES</h4>

        <h5>15.1</h5>

        <p>
          This Agreement shall be construed in accordance with and governed by the laws of Sweden.
        </p>

        <h5>15.2</h5>

        <p>
          Disputes arising out of the Terms shall be settled in Swedish public court with the
          Stockholm civil court as the first instance.
        </p>
      </div>
      <Footer />
    </>
  )
}
